/**
 * Retourne true si le rôle est de type "auditeur externe".
 * Couvre à la fois 'audit' (auditeur légal) et 'expert_comptable' (expert-comptable).
 * Ces deux rôles partagent le même comportement dans l'application (lecture seule,
 * accès aux états financiers, sans pouvoir ajouter la mention "Audité").
 */
export const isAuditRole = (role?: string | null): boolean =>
  role === 'audit' || role === 'expert_comptable';
